import { createPortal } from "react-dom";
import { formatTargetPrice } from '../../Utils/formatTargetPrice';
import React, { useState, useEffect, useRef } from "react";
import firebase from "../../Firebase/firebaseConnection";
import { Search, Star, XCircle, Archive, Unlock, ArrowUp, ArrowDown, ArrowLeft, MessageCircle } from "react-feather";
import Target from "./Target";
import Header from "../../Static/Header";
import Footer from "../../Static/Footer";
import PremiumNextStock from "../../img/premium-logo.png";
// import logoNextStock from "../../img/logo.png";
import NextStockTitleMark from "../../components/NextStockTitleMark";
import CompanyLogos from "../../components/CompanyLogos";
import { useSettingsManager } from "../../Configuration/SettingsManager";
import "./Search.css";

import { useTranslation } from "react-i18next";

import AlertManager from "../../Resources/AlertManager";

export default function Searchp({ setPage }) {

  const { t, i18n } = useTranslation();
  const introStart = useRef(Date.now());
  const [introElapsed, setIntroElapsed] = useState(0);
  const [firstVisit] = useState(() => {
    try {
      if (sessionStorage.getItem("ns-search-intro-seen")) return false;
      sessionStorage.setItem("ns-search-intro-seen", "1");
    } catch (_) { /* Storage may be unavailable. */ }
    return true;
  });

  const { user, handleSettingsPress, loadUserAccess } = useSettingsManager();

  const [targets, setTargets] = useState([]);
  const [loadedTargetCountries, setLoadedTargetCountries] = useState([]);
  const [searchText, setSearchText] = useState("");
  // Only show the return affordance for navigation initiated by an AI stock card.
  const [showReturnToAi, setShowReturnToAi] = useState(() => {
    return false; // Show only after the incoming AI ticker matches a real stored target.
  });
  const dismissAiReturn = () => {
    setShowReturnToAi(false);
    try { sessionStorage.removeItem('ns-search-from-ai'); } catch (_) {}
  };
  const returnToAi = () => {
    dismissAiReturn();
    setPage('ai-chat');
  };

  const [filteredTargets, setFilteredTargets] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedCodes, setSelectedCodes] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  // Lock background scrolling only while the comparison dialog is open.
  useEffect(() => {
    if (!isModalVisible) return undefined;
    const scrollY = window.scrollY;
    const body = document.body;
    const previous = { position: body.style.position, top: body.style.top, left: body.style.left, right: body.style.right, width: body.style.width, overflow: body.style.overflow };
    Object.assign(body.style, { position: 'fixed', top: `-${scrollY}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
    return () => {
      Object.assign(body.style, previous);
      window.scrollTo(0, scrollY);
    };
  }, [isModalVisible]);

  const [onCodeStatus, setOnCodeStatus] = useState(false);
  const [currentRemovedCodeActive, setCurrentRemovedCodeActive] = useState(false);
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);

  // useEffect(() => {
  //   async function init() {
  //     await loadUserAccess();   // 👈 segurança principal
  //     if (user.hasSearchAccess || user.trial) {
  //       getTargets("CADtarget", "CAD");
  //       getTargets("UStarget", "US");
  //     }
  //   }
  //   init();
  // }, []);

  useEffect(() => {
    async function init() {
      setIsCheckingAccess(true);

      await loadUserAccess();

      setIntroElapsed(Math.min(4200, Date.now() - introStart.current));
      setIsCheckingAccess(false);
    }

    init();
  }, []);

  useEffect(() => {
    if (
      !isCheckingAccess &&
      (user.hasSearchAccess || user.trial)
    ) {
      getTargets("CADtarget", "CAD");
      getTargets("UStarget", "US");
    }
  }, [
    isCheckingAccess,
    user.hasSearchAccess,
    user.trial
  ]);

  useEffect(() => {
    if (user.hasSearchAccess || user.trial) {
      getTargets("CADtarget", "CAD");
      getTargets("UStarget", "US");
    }
  }, [user.hasSearchAccess]);

  async function getTargets(target, country) {
    try {
      const snapshot = await firebase.database().ref(target).orderByChild("propertyShortName").once("value");
      const dataList = [];
      snapshot.forEach((item) => {
        dataList.push({
          key: item.key,
          calculatedDividend: item.val().propertyCalculatedDividend,
          currentPrice: item.val().propertyCurrentPrice,
          dividendDollar: item.val().propertyDividendDollar,
          dividendPercent: item.val().propertyDividendPercent,
          propertyCalculatedDividend: item.val().propertyCalculatedDividend,
          newPrice: item.val().propertyNewPrice,
          ps: item.val().propertyPS,
          pricePercent: item.val().propertyPricePercent,
          shortName: item.val().propertyShortName,
          symbol: item.val().propertySymbol,
          country: country,
        });
      });
      setTargets((prevArray) => [...prevArray.filter((item) => item.country !== country), ...dataList]);
      setLoadedTargetCountries((prev) => prev.includes(country) ? prev : [...prev, country]);
    } catch (error) {
      console.error("Error fetching targets:", error);
    }
  }

  const removeDuplicates = (array) => {
    const seen = new Set();
    return array.filter((item) => {
      const duplicate = seen.has(item.key);
      seen.add(item.key);
      return !duplicate;
    });
  };

  const quickSearches = [
    { label: "Apple", symbol: "AAPL" },
    { label: "Microsoft", symbol: "MSFT" },
    { label: "Tesla", symbol: "TSLA" },
    { label: "Amazon", symbol: "AMZN" },
    { label: "Meta", symbol: "META" },
  ];

  const handleSearch = (value = searchText) => {
    const searchTerm = value.trim().toLowerCase();
    setHasSearched(Boolean(searchTerm));

    if (!searchTerm) {
      setFilteredTargets([]);
      return;
    }

    const exactMatch = targets.find(
      (item) =>
        (typeof item.shortName === "string" && item.shortName.toLowerCase() === searchTerm) ||
        (typeof item.symbol === "string" && item.symbol.toLowerCase() === searchTerm)
    );

    if (exactMatch) {
      setFilteredTargets([exactMatch]);
      return;
    }

    const partialMatches = targets.filter(
      (item) =>
        (typeof item.shortName === "string" && item.shortName.toLowerCase().includes(searchTerm)) ||
        (typeof item.symbol === "string" && item.symbol.toLowerCase().includes(searchTerm))
    );

    setFilteredTargets(partialMatches);
  };

  // AI Chat deep-link: wait for the stock dataset and access check before filtering.
  const [pendingAiSymbol, setPendingAiSymbol] = useState(() => {
    try { return sessionStorage.getItem('ns-search-pending-symbol') || ''; } catch (_) { return ''; }
  });
  useEffect(() => {
    if (!pendingAiSymbol || isCheckingAccess || !(user.hasSearchAccess || user.trial) || !loadedTargetCountries.includes("CAD") || !loadedTargetCountries.includes("US")) return;
    setSearchText(pendingAiSymbol);
    handleSearch(pendingAiSymbol);
    // A return shortcut only makes sense if this AI navigation actually resolved
    // a stock and applied its filter (not on an empty/unmatched Search page).
    const normalizedSymbol = pendingAiSymbol.trim().toLowerCase();
    const exactAiTarget = targets.some(item =>
      typeof item.symbol === 'string' && item.symbol.trim().toLowerCase() === normalizedSymbol
    );
    let cameFromAi = false;
    try { cameFromAi = sessionStorage.getItem('ns-search-from-ai') === '1'; } catch (_) {}
    setShowReturnToAi(cameFromAi && exactAiTarget);
    if (!exactAiTarget) {
      try { sessionStorage.removeItem('ns-search-from-ai'); } catch (_) {}
    }
    setPendingAiSymbol('');
    try { sessionStorage.removeItem('ns-search-pending-symbol'); } catch (_) {}
  }, [pendingAiSymbol, isCheckingAccess, user.hasSearchAccess, user.trial, targets, loadedTargetCountries]);

  const handleQuickSearch = (symbol) => {
    dismissAiReturn();
    setSearchText(symbol);
    handleSearch(symbol);
  };

  const handleTextChange = (text) => {
    dismissAiReturn();
    setSearchText(text);
    if (!text.trim()) {
      setFilteredTargets([]);
      setHasSearched(false);
    }
  };

  const clearSearch = () => {
    dismissAiReturn();
    setSearchText("");
    setFilteredTargets([]);
    setHasSearched(false);
  };

  const handleTextSubmit = () => {
    if (searchText.length > 2) {
      handleSearch();
    } else {
      AlertManager.show({
        type: "message", // "error", "warning", or "message"
        title: "Instruction",
        message: "Please, type at least 3 characters to search.",
        buttonText: "Got it!"
      });
      setFilteredTargets([]);
    }
  };

  const toggleModal = () => setModalVisible((prev) => !prev);

  const handleSelectedCode = (code) => {
    console.log("Selected Code:", code);
    setSelectedCodes((prevCodes) => [...prevCodes, code]);
  };

  const handleRemoveCode = (code) => {
    setCurrentRemovedCodeActive(code);
    setSelectedCodes((prevCodes) => prevCodes.filter((c) => c !== code));
    toggleOnCodeStatus();
  };

  const handleClearList = () => {
    selectedCodes.forEach((code, index) => {
      setTimeout(() => {
        setCurrentRemovedCodeActive(code);
        toggleOnCodeStatus();
        if (index === selectedCodes.length - 1) {
          setSelectedCodes([]);
        }
      }, index * 100);
    });
  };

  const toggleOnCodeStatus = () => {
    setOnCodeStatus((prev) => !prev);
  };

  const rankedFilteredTargets = removeDuplicates(filteredTargets)
    .sort((a, b) => (Number(b.pricePercent) || 0) - (Number(a.pricePercent) || 0));

  const selectedTargets = selectedCodes
    .map(code => targets.find(target => target.shortName === code || target.symbol === code))
    .filter(Boolean)
    .sort((a, b) => (Number(b.pricePercent) || 0) - (Number(a.pricePercent) || 0));

  const bestTarget = selectedTargets[0];
  const lowestTarget = selectedTargets[selectedTargets.length - 1];

  return (
    <div className={`home-container search-page${!hasSearched ? " search-page-idle" : " search-page-active"}${firstVisit ? " search-first-visit" : ""}`} style={{ "--search-intro-elapsed": `${introElapsed}ms` }}>

      <Header setPage={setPage} />

      {/* <img src={PremiumNextStock} alt="Premium Logo" className="logo-circle" />
      <p className="logo-your" style={{ marginBottom: "-1px" }}>
        {t("search.your")}
      </p>
      <img src={logoNextStock} alt="Logo" className="logo-text" /> */}

      <div className="search-title-row">
        <NextStockTitleMark className="top10-logo-next-stock" />

        <h2 className="search-title">
          {t("search.title") || "SEARCH"}
        </h2>

        <NextStockTitleMark className="top10-logo-next-stock" />
      </div>

      <p className="search-subtitle">
        USA & CANADA
      </p>

      <p className="search-plan-line">
        {t("search.plan")}: <strong>{(user.planType || "free").toUpperCase()}</strong>
      </p>

      {showReturnToAi && !isCheckingAccess && (user.hasSearchAccess || user.trial) && (
        <div className="search-ai-return-wrap">
          <button type="button" className="search-ai-return" onClick={returnToAi} aria-label="Return to Next Stock AI Chat">
            <span className="search-ai-return-icon"><ArrowLeft size={17} /><MessageCircle size={17} /></span>
            <span className="search-ai-return-copy"><strong>Back to AI Chat</strong><small>Continue your conversation</small></span>
            <span className="search-ai-return-arrow" aria-hidden="true">↗</span>
          </button>
        </div>
      )}

      {isCheckingAccess ? (

        <div className="plan-container">
          <div className="search-loading-card">
            <div className="search-loading-spinner"></div>
            <p>{t("header.loading")}</p>
          </div>
        </div>

      ) : !user.hasSearchAccess && !user.trial ? (

        <div className="plan-container">
          <div className="search">
            <Search className="icon" />
            <input
              type="text"
              placeholder={t("search.blocked")}
              value={t("search.blocked")}
              disabled
              className="search-input"
            />
          </div>

          <p className="upgrade-text">
            {t("search.upgradeText")}
          </p>

          <button
            className="home-upgrade-btn"
            onClick={handleSettingsPress}
          >
            <Unlock size={14} />
            {t("search.upgradePlan")}
          </button>
        </div>

      ) : (
        <div className="premium-plan">

          {selectedCodes.length > 0 && (
            <div className="comparison-status-card">
              <button className="comparison-status-open" onClick={toggleModal}>
                <Archive size={16} />
                <span>
                  {t("search.seeComparisonList", { count: selectedCodes.length })}
                </span>
              </button>

              <button className="comparison-status-clear" onClick={handleClearList}>
                <XCircle size={14} />
                {t("search.clearList")}
              </button>
            </div>
          )}

          <div className="search">
            <Search className="icon" size={18} />

            <input
              type="text"
              placeholder={t("search.searchAndCompare")}
              value={searchText}
              onChange={(e) => handleTextChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleTextSubmit();
                  e.currentTarget.blur();
                }
              }}
              className="search-input"
            />

            {searchText && (
              <button type="button" className="search-clear-btn" onClick={clearSearch} aria-label="Clear search">
                <XCircle size={19} />
              </button>
            )}

            <button
              className="search-btn"
              onClick={handleTextSubmit}
            >
              <Search size={16} />
            </button>
          </div>
          {!hasSearched && !searchText.trim() && (
            <div className="search-quick-examples" aria-label="Quick stock searches">
              {quickSearches.map(({ label, symbol }, index) => (
                <button key={symbol} type="button" className="search-quick-chip"
                  style={{ "--quick-index": index }} onClick={() => handleQuickSearch(symbol)}
                  title={`${label} (${symbol})`}>
                  <span className="search-quick-logo"><CompanyLogos symbol={symbol} /></span>
                  <span className="search-quick-name">{label}</span>
                  <span className="search-quick-symbol">{symbol}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      <p className="results-text">📌 {rankedFilteredTargets.length} {t("search.results")}</p>

      <div className="target-list">
        {rankedFilteredTargets.map((item, index) => (
          <Target
            key={item.key}
            data={{ ...item, rank: index + 1 }}
            selectedCodes={selectedCodes}
            onCodeSelected={handleSelectedCode}
            onCodeRemoved={handleRemoveCode}
            onCodeStatusChange={onCodeStatus}
            currentRemovedCodeActive={currentRemovedCodeActive}
          />
        ))}
      </div>

      <Footer />



      {selectedCodes.length > 0 && !isModalVisible && createPortal(
        <button className="floating-compare-btn" onClick={toggleModal}>
          <Archive size={18} />
          {t("search.seeComparisonList", { count: selectedCodes.length })}
        </button>, document.body
      )}

      {isModalVisible && createPortal(
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="comparison-modal" onClick={(e) => e.stopPropagation()}>

            <div className="comparison-modal-header">
              <div>
                {/* <span className="comparison-label" style={{marginLeft:"-10px"}}>Next Stock</span> */}
                <h3>{t("search.selectedTargets")} ({selectedTargets.length})</h3>
              </div>

              <button className="comparison-close-btn" onClick={toggleModal}>
                <XCircle size={22} />
              </button>
            </div>

            {selectedTargets.length > 0 && (
              <div className="comparison-summary">
                <div className="comparison-summary-card">
                  <span>{t("search.bestUpside")}</span>
                  <strong>{bestTarget?.shortName || "N/A"}</strong>
                  <p className={Number(bestTarget?.pricePercent) >= 0 ? "positive" : "negative"}>
                    {bestTarget?.pricePercent ?? "n/a"}%
                  </p>
                </div>

                <div className="comparison-summary-card">
                  <span>{t("search.lowestUpside")}</span>
                  <strong>{lowestTarget?.shortName || "N/A"}</strong>
                  <p className={Number(lowestTarget?.pricePercent) >= 0 ? "positive" : "negative"}>
                    {lowestTarget?.pricePercent ?? "n/a"}%
                  </p>
                </div>

                <div className="comparison-summary-card">
                  <span>{t("search.selectedStocks")}</span>
                  <strong>{selectedTargets.length}</strong>
                  <p>Ranked by upside</p>
                </div>
              </div>
            )}

            <div className="comparison-list">
              {selectedTargets.length > 0 ? (
                selectedTargets.map((fullTarget, index) => (
                  <div
                    key={fullTarget.key}
                    className={`comparison-card ${index === 0 ? "comparison-best" : ""} ${index === selectedTargets.length - 1 ? "comparison-lowest" : ""}`}
                  >
                    <div className="comparison-rank">{index + 1}</div>

                    <div className="comparison-info">
                      <h4>{fullTarget.shortName}</h4>
                      <p>{fullTarget.symbol} · {fullTarget.country === "CAD" ? "🇨🇦 Canada" : "🇺🇸 USA"}</p>
                    </div>

                    <div className="comparison-metrics">
                      <div>
                        <span>{t("search.lastRecordedPrice")}</span>
                        <strong>${fullTarget.currentPrice ?? "n/a"}</strong>
                      </div>

                      <div>
                        <span>{t("search.targetPrice")}</span>
                        <strong>${formatTargetPrice(fullTarget.newPrice)}</strong>
                      </div>

                      <div>
                        <span>{t("search.priceChange")}</span>
                        <strong className={Number(fullTarget.pricePercent) >= 0 ? "positive" : "negative"}>
                          {fullTarget.pricePercent ?? "n/a"}%
                        </strong>
                      </div>
                    </div>

                    <button
                      className="comparison-remove-btn"
                      onClick={() => handleRemoveCode(fullTarget.shortName)}
                    >
                      <XCircle size={18} />
                    </button>
                  </div>
                ))
              ) : (
                <div className="comparison-empty">
                  No stocks selected yet.
                </div>
              )}
            </div>

          </div>
        </div>
      , document.body)}



    </div>
  );

}
